















import { Component, Mixins, Prop } from "vue-property-decorator";
import { Department, DepartmentGroup } from "../../../domain/department";
import { User } from "../../../domain/user";
import { HisItemParameter } from "../../../domain/his/behavior";
import { IHisInfoSelectDialog } from "./IHisInfoSelectDialog";
import { IHisInformationGroupSource, HisInformationUserGroupSource } from "../../../domain/his/groupInput/HisInformationGroupSource";
import { IConfiguration } from "../../../domain/configuration";
import { IUserListSelectorDialogCondition, IMultiOrderableUserListSelectorDialogCondition } from "../../user/dialogs";
import UserListSelectorDialog from "../../user/dialogs/UserListSelectorDialog.vue";
import MultiOrderableUserListSelectorDialog from "../../user/dialogs/MultiOrderableUserListSelectorDialog.vue";

@Component({
  components: {
    UserListSelectorDialog,
    MultiOrderableUserListSelectorDialog,
  },
})
export default class HisInfoUserSelectDialog extends Mixins() implements IHisInfoSelectDialog {
  @Prop()
  parameter: HisItemParameter;

  @Prop()
  selectedItems: User[];

  department: Department;
  multiDialog: MultiOrderableUserListSelectorDialog;
  singleDialog: UserListSelectorDialog;

  data(): any {
    return {
      department: null as Department,
      multiDialog: null as MultiOrderableUserListSelectorDialog,
      singleDialog: null as UserListSelectorDialog,
    };
  }

  mounted(): void {
    this.singleDialog = this.$refs.single as UserListSelectorDialog;
    this.multiDialog = this.$refs.multi as MultiOrderableUserListSelectorDialog;
  }

  get shouldSelectMulti(): boolean {
    return this.parameter.isMultiSelect;
  }

  get defaultSelectedDepartment(): Department {
    return this.$store.getters.department;
  }

  get defaultDepartmentId(): string {
    return this.defaultSelectedDepartment
      ? this.defaultSelectedDepartment.id
      : null;
  }

  get defaultSelectedProfessionCodes(): string[] {
    const config = this.$store.getters.configuration as IConfiguration;
    return config.behavior.user.finder.doctorProfessionCodes;
  }

  get userListSelectorDialogCondition(): IUserListSelectorDialogCondition {
    return {
      name: "職員",
      departmentId: this.department
        ? this.department.id
        : this.defaultDepartmentId,
      defaultSelectedProfessionCodes: this.defaultSelectedProfessionCodes,
    };
  }

  get multiOrderableUserListSelectorDialogCondition(): IMultiOrderableUserListSelectorDialogCondition {
    return {
      name: "職員",
      isMultiSelectable: false,
      departmentId: this.department
        ? this.department.id
        : this.defaultDepartmentId,
      defaultSelectedProfessionCodes: this.defaultSelectedProfessionCodes,
      isMultiSingleSwitchable: true,
    };
  }

  departmentChanged(department: Department): void {
    this.department = department;
  }

  async show(): Promise<IHisInformationGroupSource> {
    const selected = this.shouldSelectMulti
      ? await this.showMultiDialog()
      : await this.showSingleDialog();
    return new HisInformationUserGroupSource(selected, this.department);
  }

  private async showMultiDialog(): Promise<User[]> {
    const selected = await this.multiDialog.selectOptionsConditionally(
      this.multiOrderableUserListSelectorDialogCondition,
      this.selectedItems,
    );
    return selected;
  }

  private async showSingleDialog(): Promise<User[]> {
    const selected = await this.singleDialog.selectOptionConditionally(
      this.userListSelectorDialogCondition,
      this.selectedItems
        ? this.selectedItems[0]
        : null,
    );
    if (selected === null) { return null; } // クリア
    if (selected === undefined) { return undefined; } // キャンセル

    return [ selected ];
  }

  get departmentGroup(): DepartmentGroup {
    return this.$configuration.behavior.document.editor.departmentGroup.shouldIgnoreDepartmentGroupFilter ? null : undefined;
  }
}
